module.exports = __webpack_public_path__ + "static/media/Gor 2018.11.18.fe86d8c0.webp";